import { LoadingSpinnerIcon, StarIcon } from '@/components/icons';
import { Box, Button, Typography } from '@mui/material';
import { rightPanelStyles } from './styles';

const LoadingState = () => {
  const handleOpenNewTab = () => {
    window.open(window.location.href, '_blank');
  };
  return (
    <Box sx={rightPanelStyles.loadingContainer}>
      {/* Header with stars icon and "Generating notes" */}
      <Box sx={rightPanelStyles.header}>
        <Box sx={rightPanelStyles.iconContainer}>
          <StarIcon />
        </Box>
        <Typography sx={rightPanelStyles.headerTitle}>
          Generating notes
        </Typography>
      </Box>

      {/* Subtitle */}
      <Typography sx={rightPanelStyles.loadingSubtitle}>
        While waiting you can start a new audio
      </Typography>

      <Button
        onClick={handleOpenNewTab}
        sx={rightPanelStyles.newAudioButton}
        disableRipple
      >
        <Typography sx={rightPanelStyles.newAudioButtonText}>
          NEW AUDIO
        </Typography>
      </Button>

      {/* Loading animation with circles */}
      <Box sx={rightPanelStyles.loadingAnimation}>
        <Box sx={rightPanelStyles.outerCircle} />
        <Box sx={rightPanelStyles.innerCircle} />
        <Box sx={rightPanelStyles.loadingIcon}>
          <LoadingSpinnerIcon />
        </Box>
      </Box>

      {/* Warning text */}
      <Typography sx={rightPanelStyles.warningText}>
        Generating notes takes almost one minute PER minute of recorded audio.
        Please do not close this window
      </Typography>

      {/* Bottom tagline */}
      <Typography sx={rightPanelStyles.taglineText}>
        Your A.I Co-Pilot For Medical Documentation !
      </Typography>

      {/* Additional info */}
      <Typography sx={rightPanelStyles.additionalInfo}>
        While our super - smart Ai model is busy crafting the perfect notes from
        your audio why not visit{' '}
        <Box
          component="span"
          sx={rightPanelStyles.scriberainHighlight}
          onClick={() => window.open('https://scribebrain.com/', '_blank')}
        >
          ScriberainAI
        </Box>{' '}
        ?
      </Typography>
    </Box>
  );
};

export default LoadingState;
